import { FormGroup } from '@angular/forms';

import { FormControl } from '@angular/forms';
import { MarkGroup, SolutionPath } from '@examdojo/models/markscheme-v2';
import { QuestionEditingOptions } from '@examdojo/models/question-editor';
import { ContentItemFormArray, createContentItemsFormArray } from '@examdojo/question-content-item';

export type WorkedSolutionFormCtrl = ContentItemFormArray;

export type SolutionPathFormGroup = FormGroup<{
  mark_group_refs: FormControl<Array<MarkGroup['id']>>;
  worked_solution: WorkedSolutionFormCtrl;
}>;

export function createSolutionPathFormGroup(
  solutionPath: SolutionPath | undefined,
  options: QuestionEditingOptions,
): SolutionPathFormGroup {
  return new FormGroup({
    mark_group_refs: new FormControl(solutionPath?.mark_group_refs ?? [], { nonNullable: true }),
    worked_solution: createContentItemsFormArray(solutionPath?.worked_solution ?? [], {
      allowTextEditing: options.allowMarkschemeEditing,
      allowImageEditing: options.allowImageEditing,
      allowFillInTheBlanks: false,
      hideImageAndTableMetadata: options.hideImageAndTableMetadata,
    }),
  });
}
